export default {
  operator: "Operator",
  selectField: "Feld auswählen",
  selectOperator: "Operator auswählen",
  rule: "Regel",
  ruleSet: "Regelset",
  not: "Nicht",
  selectValueSource: "Wertquelle wählen",
  errorGroupQuery: "Es konnten keine Ergebnisse zurückgegeben werden, da es ein Problem mit der Regeldefinition gibt.",
  updateQueryMessage: "Bitte aktualisieren Sie die Regeldefinition für Ihre Gruppe um Ergebnisse zu erhalten.",
  emptyGroupNameMessage: "Der Gruppenname darf nicht leer sein.",
};
